
export const Clients = () => import('./Clients').then(({ Clients }) => {
  return {
    Component: Clients
  };
});
